export * from './universe.component';
export * from './universe.state';
export * from './detail/detail.component';
export * from './detail/detail.state';
export * from './create/create.component';
export * from './create/create.state';



// WEBPACK FOOTER //
// ./src/app/_screens/directory/universe/index.ts